export const ADD_CONTACT_US_REQUEST =   "ADD_CONTACT_US_REQUEST";
export const ADD_CONTACT_US_SUCCESS =   "ADD_CONTACT_US_SUCCESS";
export const ADD_CONTACT_US_FAIL =   "ADD_CONTACT_US_FAIL";

export const GET_CONTACT_US_LIST_REQUEST =   "GET_CONTACT_US_LIST_REQUEST";
export const GET_CONTACT_US_LIST_SUCCESS =   "GET_CONTACT_US_LIST_SUCCESS";
export const GET_CONTACT_US_LIST_FAIL =   "GET_CONTACT_US_LIST_FAIL";
